<main class="erp">
  <div class="erp-card">
    <div class="erp-icon" aria-hidden="true">!</div>

    <h1 #heading tabindex="-1" class="erp-title">{{ 'ERROR_REPORTING.TITLE' | translate }}</h1>
    <p class="erp-lead">{{ 'ERROR_REPORTING.RECOVERY.LEAD' | translate }}</p>

    <div class="erp-actions">
      <button type="button" class="erp-btn erp-btn--primary" (click)="goHome()">
        {{ 'ERROR_REPORTING.RECOVERY.GO_HOME' | translate }}
      </button>
      <button type="button" class="erp-btn" (click)="reload()">
        {{ 'ERROR_REPORTING.RECOVERY.RELOAD' | translate }}
      </button>
    </div>

    @if (incident(); as incident) {
      <div class="erp-report">
        <h2 class="erp-report__title">{{ 'ERROR_REPORTING.RECOVERY.REPORT_TITLE' | translate }}</h2>
        <lib-error-report-form [context]="incident" />
      </div>
    }
  </div>
</main>
